window.onerror = function(msg, url, line, col, error) {
    if (msg.includes('No start page has been defined')) {
        window.location.reload();
    }
};
